import svgIcon from '@/components/icon/svg'

const className = 'ws'

export default function(h) {
  let connectionColor = 'error'
  let connectionKey = 'disconnected'
  if (this.ws?.connected) {
    connectionColor = 'success'
    connectionKey = 'connected'
  }

  return h(
    'div',
    {
      class: `${className}-connection`,
      directives: [
        {
          name: 'g-tooltip',
          options: {
            value: this.getTranslate(`${className}.tooltips.connection`)
          }
        }
      ]
    },
    [
      h(
        svgIcon,
        {
          props: {
            value: 'ws',
            color: connectionColor
          }
        }
      ),

      h(
        'div',
        {
          class: `${className}-connection__label text--grey`
        },
        [ this.getTranslate(`${className}.labels.${connectionKey}`) ]
      )
    ]
  )
}
